<template>
  <div :id="echartId" class="echarts-main"></div>
</template>
<script>
import { v4 } from "uuid"
import * as echarts from "echarts"
export default {
  props: {
    echartsData: {
      default: () => ({
        conditions: [],
        proportions: [],
        network: "",
        speedType: "",
      }),
    },
  },
  data () {
    return {
      option: {
        // title: {
        //   text: '%'
        // },
        tooltip: {
          trigger: "axis",
          formatter: "",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: 4,
          padding: [
            8, // 上
            9, // 右
            8, // 下
            11, // 左
          ],
        },
        grid: {
          //设置x轴与y轴位于盒子间的距离
          top: "53",
          left: "40",
          right: 50,
          bottom: "45",
        },
        xAxis: {
          scale: false,
          // splitNumber: 5,
          name: "Mbps",
          axisTick: {
            interval: function (value, index) {
              console.log(value, index)
            },
          },
          nameTextStyle: {
            //x轴name样式
            color: "#82889A",
            fontWeight: 500,
            fontSize: 12,
            align: "center",
            padding: [8, 0, 0, 25],
            verticalAlign: "top",
          },
          type: "category",
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false, //不显示坐标轴刻度线
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            interval: function (value, index) {
              console.log(value, index)
            },
          },
          name: "%",
          nameTextStyle: {
            //y轴name样式
            color: "#82889A",
            fontWeight: 500,
            fontFamily: "SourceHanSansSC-Regular, SourceHanSansSC;",
            fontSize: "12",
            padding: [0, 0, 0, -24],
          },
          axisLine: {
            //y轴轴线
            show: true,
            lineStyle: {
              color: "#5B6189",
              width: 1,
            },
          },
          splitLine: {
            //分隔线
            lineStyle: {
              color: "#5B6189",
              width: 1,
            },
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 500,
            color: "#82889A",
          },
        },
        series: [
          {
            name: "4G1网络",
            type: "line",
            tooltip: {
              formatter: "{b0}: {c0}<br />{b1}: {c1}",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#50E3C2 " },
                { offset: 1, color: " rgba(80, 227, 194, 0) " },
              ]),
            },
            // smooth: true,//平滑曲线
            symbol: "none", //隐藏折线点
            data: [20, 30, 100, 10],
            lineStyle: {
              color: "#50E3C2",
              width: 1,
            },
          },
        ],
      },
      echartId: "echart" + v4(),
      myChart: null, //全局的echars对象
    }
  },
  watch: {
    echartsData () {
      this.initEchart()
    },
  },
  methods: {
    initEchart () {
      this.option.xAxis.data = this.echartsData.conditions
      this.option.series[0].data = this.echartsData.proportions
      this.option.series[0].name = this.echartsData.network
      this.option.tooltip.formatter = `<div style='font-size: 0.12rem;font-weight: 400;color: #5B6189;line-height: 0.18rem;'>{a0}</div><div style='width: 1rem;height: 0.18rem;font-size: 0.12rem;font-weight: 400;color: #333333;line-height: 0.18rem;'>${this.echartsData.speedType} {b0}Mbps</div><div style='width: 1rem;height: 0.18rem;font-size: 0.12rem;font-weight: 400;color: #333333;line-height: 0.18rem;'>占比  <span style='color:#FF8451;'>{c0}%</span></div>`
      this.$nextTick(() => {
        //判断图表是否已经存在再次重新渲染
        if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
          this.myChart.dispose()//销毁
        }
        this.myChart = echarts.init(
          document.getElementById(this.echartId),
          null,
          { renderer: "svg" }
        )
        this.myChart.setOption(this.option)
        window.addEventListener("resize", () => {
          this.myChart.resize()
        })
      })
    },
  },
  mounted () {
    this.echartId = "echart" + v4()
    this.initEchart()
  },
};
</script>
<style lang="less" scoped>
.echarts-main {
  width: 100%;
  height: 100%;
}
</style>